import { KameleonBase } from "./kameleon-base";
import { themeColor } from "./theme-helper";

export const Alpha: typeof KameleonBase & any = () => ({
  colors: {
    variables: {
      _neutral: "#F7FBF3",
      _mainCTA: "#84B118",
      _secondaryCTA: "#E27700",
      _dark: "#CE1F48",
      _darkest: "#00211A",
      _neutralLight: "#FFFFFF",
    },
  },
  fontSizes: [
    "0.75rem",
    "0.875rem",
    "1rem",
    "1.125rem",
    "1.25rem",
    "1.5rem",
    "1.75rem",
    "2rem",
    "2.25rem",
    "2.5rem",
    "2.75rem",
    "3rem",
    "3.25rem",
    "3.5rem",
    "3.75rem",
    "4rem",
    "4.5rem",
    "5rem",
    "5.25rem",
    "5.5rem",
    "7.5rem",
    "10rem",
  ],
  lineHeights: {
    body: 1.5,
    heading: 1.125,
  },
  text: {
    large: {
      fontSize: [5, null, 6],
    },
    medium: {
      fontSize: [3, null, 4],
    },
    mediumSmall: {
      fontSize: [2, null, 3],
    },
    small: {
      fontSize: 1,
    },
    tiny: {
      fontSize: 0,
    },
    tagline: {
      color: themeColor("primary"),
      fontSize: 1,
      backgroundColor: `color-mix(in srgb, ${themeColor(
        "primary"
      )}, transparent 85%)`,
      display: "inline",
      padding: "0.4rem 0.4rem",
      borderRadius: "4px",
    },
  },
  styles: {
    h1: {
      variant: "text.heading",
      fontSize: [14, null, 15, 16],
      lineHeight: 1.2,
    },
    h2: {
      variant: "text.heading",
      fontSize: [11, null, 14, 15],
      lineHeight: 1.2,
    },
    h3: {
      variant: "text.heading",
      fontSize: [7, null, 8, 9],
      lineHeight: 1.2,
    },
    h4: {
      variant: "text.heading",
      fontSize: [6, null, 7, 8],
      lineHeight: 1.3,
    },
    h5: {
      variant: "text.heading",
      fontSize: [5, null, 6],
      lineHeight: 1.4,
    },
    h6: {
      variant: "text.heading",
      fontSize: [4, null, 5],
      lineHeight: 1.4,
    },
    p: {
      fontSize: 2,
    },
    b: {
      fontSize: 2,
      fontWeight: "bold",
    },
  },
  cards: {
    primary: {
      bg: themeColor("cards.primary.bg"),
      boxShadow: `0 4px 28px ${themeColor("variables.grays.10")}`,
      borderRadius: "16px",
    },
    vertical: {
      default: {
        gridColumnGap: "2rem",
        gridRowGap: "1rem",
        "@media screen and (max-width: 767px)": {
          gridRowGap: "1.5rem",
          gridTemplateColumns: "1fr",
        },
        "@media screen and (max-width: 479px)": {
          gridRowGap: "1.5rem",
          gridTemplateColumns: "1fr",
          gridTemplateRows: "auto auto",
        },
      },
      content: {
        paddingTop: "2rem",
        paddingBottom: "2rem",
        paddingRight: "2rem",
        "@media screen and (max-width: 767px)": {
          paddingTop: "0",
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
    horizontal: {
      default: {},
      content: {
        paddingLeft: "2rem",
        paddingBottom: "2rem",
        paddingRight: "2rem",
        "@media screen and (max-width: 767px)": {
          paddingBottom: "1.5rem",
          paddingRight: "1.5rem",
          paddingLeft: "1.5rem",
        },
      },
    },
  },
  buttons: {
    primary: {
      color: "buttons.primaryText",
      borderRadius: "4px",
      font: "body",
      fontSize: 2,
      padding: "0.75rem 1.5rem",
      "&:focus": {
        bg: themeColor("links.hover"),
      },
      "&:hover": {
        bg: themeColor("buttons.backgroundHover"),
      },
      "&:active": {
        bg: themeColor("buttons.backgroundActive"),
      },
      "&:disabled": {
        bg: themeColor("buttons.disabled"),
        cursor: "not-allowed",
      },
    },
    secondary: {
      color: themeColor("secondary"),
      background: "none",
      cursor: "pointer",
      border: `1px solid ${themeColor("secondary")}`,
      borderRadius: "4px",
      fontSize: 2,
      padding: "0.75rem 1.5rem",
      transition: "all .1s ease-in-out",
      "&:focus": {
        bg: themeColor("buttons.secondaryBackgroundHover"),
      },
      "&:hover": {
        bg: themeColor("buttons.secondaryBackgroundHover"),
      },
      "&:active": {
        bg: themeColor("buttons.secondaryBackgroundActive"),
      },
    },
  },
  images: {
    nonBackground: {
      borderRadius: "16px",
    },
    card: {
      horizontal: {
        borderTopLeftRadius: "16px",
        borderTopRightRadius: "16px",
      },
      vertical: {
        borderTopLeftRadius: "16px",
        borderBottomLeftRadius: "16px",
      },
    },
  },
  boxes: {
    header: {
      navbar: {
        // currently a not fully working example
        // backdropFilter: "blur(5px)",
        // backgroundColor: `color-mix(in srgb, ${themeColor("navbar.dropdown")}, transparent 80%) !important`
      },
    },
    footer: {
      borderRadius: "16px",
    },
    slider: {
      boxShadow: "large",
      borderRadius: "16px",
      slide: {
        backgroundColor: themeColor("muted"),
      },
    },
    animations: {
      tertiary: {
        "@keyframes fadeIn": {
          "0%": {
            opacity: 0,
          },
          "100%": {
            opacity: 1,
          },
        },
        animation: "fadeIn 2s",
      },
    },
  },
});
